<template>
  <div class="m-planSet">
    <a-form class="m-form"
            :form="form">
      <div class="u-modle-p">品牌选择</div>
      <a-form-item label="来源公司"
                   v-bind="formItemLayout"
                   v-if="userInfo.userType == 5">
        <a-select style="width: 284px"
                  showSearch
                  :filterOption="filterOption"
                  v-decorator="[
            'originCompanyId',
            { rules: [{ required: true, message: '请选择来源公司' }] }
          ]"
                  placeholder="请选择"
                  @change="changeOriginCompany">
          <a-select-option v-for="(item, index) in originCompanyList"
                           :key="index"
                           :value="item.value"
                           :label="item.label"
                           :name="item.label">
            {{ item.label }}
          </a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item label="来源销售"
                   v-bind="formItemLayout"
                   v-if="userInfo.userType == 5">
        <a-select style="width: 284px"
                  showSearch
                  :filterOption="filterOption"
                  v-decorator="[
            'originUserId',
            { rules: [{ required: true, message: '请选择来源销售' }] }
          ]"
                  placeholder="请选择"
                  @change="changeOriginUser">
          <a-select-option v-for="(item, index) in originUserList"
                           :value="item.value"
                           :label="item.label"
                           :name="item.label"
                           :key="index">
            {{ item.label }}
          </a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item label="销售"
                   v-bind="formItemLayout"
                   v-if="userInfo.assistCreatePlan == 1">
        <a-select style="width: 284px"
                  showSearch
                  :filterOption="filterOption"
                  v-decorator="[
            'saleId',
            { rules: [{ required: true, message: '请选择所属销售' }] }
          ]"
                  placeholder="请选择"
                  @change="changeSale">
          <a-select-option v-for="(item, index) in sales"
                           :value="item.userId"
                           :name="item.realName"
                           :key="index">{{ `${item.realName} ` }}
            <span class="user-name">{{ item.userName || '' }}</span>
          </a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item label="广告主"
                   v-bind="formItemLayout">
        <a-select style="width: 284px"
                  showSearch
                  :filterOption="filterOption"
                  v-decorator="[
            'company',
            { rules: [{ required: true, message: '请选择广告主名称' }] }
          ]"
                  placeholder="请选择"
                  @change="changeCompany">
          <a-select-option v-for="(item, index) in companyNames"
                           :value="item.cID"
                           :name="item.companyNames"
                           :key="index">{{ item.companyNames }}
          </a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item label="品牌"
                   v-bind="formItemLayout">
        <a-select style="width: 284px"
                  showSearch
                  :filterOption="filterOption"
                  v-decorator="['brand']"
                  placeholder="请选择"
                  @change="changeBrands">
          <a-select-option v-for="(item, index) of companyBrands"
                           :value="item.bID"
                           :key="index">
            {{ item.bTitle }}
          </a-select-option>
        </a-select>
      </a-form-item>
      <div class="u-modle-p">投放设置</div>
      <a-form-item label="计划名称"
                   v-bind="formItemLayout">
        <a-input style="width: 284px"
                 v-decorator="[
            'planName',
            { rules: [{ required: true, message: '请选择计划名称' }] }
          ]"
                 @blur="changePlanName"
                 placeholder="请选择">
        </a-input>
      </a-form-item>
      <a-form-item label="广告主行业"
                   v-bind="formItemLayout">
        <a-cascader v-decorator="[
            'adType',
            { rules: [{ required: true, message: '请选择广告主行业' }] }
          ]"
                    style="width: 284px"
                    :options="adSys"
                    @change="changeAdSystem"
                    placeholder="请选择" />
      </a-form-item>
      <a-form-item v-bind="formItemLayout">
        <span slot="label"> 展现机制 </span>
        <a-radio-group v-decorator="[
            'isBilling',
            {
              rules: [{ required: true, message: '请选择展现机制' }],
              initialValue: '1'
            }
          ]"
                       @change="changeAdType">
          <a-radio value="1">轮播</a-radio>
          <a-tooltip class="u-radio-tooltip"
                     title="主动展现，不需要条件触发即可进行广告播放">
            <a-icon type="question-circle-o" />
          </a-tooltip>
          <a-radio value="2">触发</a-radio>
          <a-tooltip class="u-radio-tooltip"
                     title="需要满足触发条件，才会展现广告">
            <a-icon type="question-circle-o" />
          </a-tooltip>
        </a-radio-group>
      </a-form-item>
      <a-form-item v-bind="formItemLayout"
                   class="row-flex">
        <span slot="label"> 广告位置 </span>
        <a-radio-group v-decorator="[
            'positionId',
            {
              rules: [{ required: true, message: '请选择广告位置' }],
              initialValue: '1'
            }
          ]"
                       @change="changePositionId">
          <span class=""
                v-for="(item, index) in adSpaceList"
                :key="index">
            <template v-if="formItem.priceStrategy == item.priceStrategy">
              <a-radio :value="item.spaceId">{{ item.spaceName }}</a-radio>
              <a-tooltip class="u-radio-tooltip"
                         :title="item.tooltip">
                <a-icon type="question-circle-o" />
              </a-tooltip>
            </template>
          </span>
        </a-radio-group>
      </a-form-item>
      <a-form-item v-bind="formItemLayout"
                   v-show="formItem.positionId == 1"
                   class="row-flex">
        <span slot="label"> 播放时段 </span>
        <a-radio-group v-decorator="[
            'deliveryPeriod',
            {
              rules: [{ required: (formItem.positionId == 1)?true:false, message: '请选择播放时段' }],
            }
          ]"
                       @change="changeDeliveryPeriodType">
          <a-radio value="1">普通时段</a-radio>
          <a-tooltip class="u-radio-tooltip"
                     title="10点~17点和21点~6点播放">
            <a-icon type="question-circle-o" />
          </a-tooltip>
          <a-radio value="2">黄金时段</a-radio>
          <a-tooltip class="u-radio-tooltip"
                     title="6点~10点和17点~21点播放">
            <a-icon type="question-circle-o" />
          </a-tooltip>
          <a-radio value="3"
                   v-if="userType == 5 || userType ==7">24小时霸屏</a-radio>
          <a-tooltip class="u-radio-tooltip"
                     title="指全天24小时播放一个广告"
                     v-if="userType == 5 || userType ==7">
            <a-icon type="question-circle-o" />
          </a-tooltip>
        </a-radio-group>
      </a-form-item>
    </a-form>
    <a-alert class="warn-box"
             message="一旦发现有上传涉毒、涉黄、涉黑等违法内容，将永久关闭后台账号，并向公安机关举报！"
             type="warning"
             show-icon />
    <div class="m-foot-btn">
      <a-button @click="backStep">取消</a-button>
      <a-button class="u-nextStep-btn"
                type="primary"
                @click="nextStep">下一步</a-button>
    </div>
  </div>
</template>
<script>
import { api } from '../../commomFun/api'
import { cacheDrafts } from '../../commomFun/cacheApi'
import timeFormat from '../../commomFun/timeFormat'
import moment from 'moment'
import { mapMutations } from 'vuex'
import { getDiffList } from '../../utils/utils'

export default {
  data() {
    return {
      adSpaceList: [
        {
          spaceId: 1,
          spaceName: '大屏轮播广告',
          priceStrategy: 1,
          priceStrategyName: '轮播广告',
          tooltip: '21.5寸以上的竖版大屏轮播屏保',
        },
        {
          spaceId: 2,
          spaceName: '大屏人脸识别精准广告',
          priceStrategy: 2,
          priceStrategyName: '精准广告',
          tooltip: '21.5寸以上的竖版大屏，在识别到人脸时，根据特征展示对应广告',
        },
        {
          spaceId: 3,
          spaceName: '开门成功精准弹窗广告',
          priceStrategy: 2,
          priceStrategyName: '精准广告',
          tooltip: '8寸屏幕在识别到人脸时，根据特征展示对应广告',
        },
        {
          spaceId: 4,
          spaceName: '对讲通话广告',
          priceStrategy: 2,
          priceStrategyName: '精准广告',
          tooltip: '8寸屏幕在对讲时，展示对应广告',
        },
        {
          spaceId: 5,
          spaceName: '开门成功弹窗广告',
          priceStrategy: 2,
          priceStrategyName: '精准广告',
          tooltip: '8寸屏幕在开门成功时，展示广告',
        },
      ],
      userInfo: '',
      formItemLayout: {
        labelCol: { span: 6 },
        wrapperCol: { span: 10 },
      },
      startValue: '',
      endValue: '',
      formItem: {
        saleId: '',
        companyId: '',
        companyName: '',
        companyBrandId: '',
        companyBrand: '',
        planName: '',
        adSystemId: '',
        adSystemName: '不限',
        priceStrategy: 1,
        positionId: 1,
        beginTime: '',
        endTime: '',
        target: '-',
        condition: '',
        originCompanyId: '', // 来源公司-全国媒介
        originCompanyName: '',
        originUserId: '', // 来源销售-全国媒介
        originUserName: '',
        playCounts: '', //播放次数
        deliveryPeriod: 1, //播放时段
        isDuration: '', //缓存播放时长？
      },
      //公司名称和品牌
      companyNames: [],
      //公司品牌
      companyBrands: [],
      //所属销售
      sales: [],
      // 广告行业
      adSys: [],
      brand: '',
      // 来源公司
      originCompanyList: [],
      // 来源销售
      originUserList: [],
      userType: '', //用户类别
    }
  },
  beforeCreate() {
    this.form = this.$form.createForm(this)
  },
  created() {
    this.userInfo = JSON.parse(sessionStorage.getItem('userInfo'))
  },
  mounted() {
    let { userType } = this.userInfo
    this.userType = userType
    this.init()

    // 获取行业类型
    this.tradeList()
    if (this.userInfo.assistCreatePlan == 1) {
      this.getSales()
    } else {
      // 获取客户列表
      if (userType !== 5) {
        this.getCompanyForUserId(this.userInfo.userId)
      }
    }
    if (userType === 5) {
      this.getOriginCompany()
    }
  },
  beforeDestroy() {
    if (sessionStorage.getItem('edit') === 'edit') {
      return
    }
    cacheDrafts(1)
  },
  methods: {
    ...mapMutations(['clearAdMaterialDetail', 'setFramesData']),
    moment,
    // 获取订单详情
    getPlanEditDetail(planID) {
      api
        .postApi('/adPlan/getPlanEditDetail?planId=' + planID)
        .then((res) => {
          if (res.data.code === 200) {
            let editPlanDetail = res.data.data
            if (!editPlanDetail.planId) {
              this.$message.warning('计划详情获取异常！')
              return
            }
            if (Array.isArray(editPlanDetail.adMaterials)) {
              let planMaterialList = {},
                regionIdToPointId = {},
                materialDetailsList = []
              editPlanDetail.adMaterials.forEach((item) => {
                planMaterialList[item.deviceModel] = item.materialId
                // 将该设备在当前计划中的唯一id（regionId）与设备PointId相关联
                item.adMachines.forEach((devItem) => {
                  regionIdToPointId[devItem.pointId] = devItem.regionId
                })
                if (item.adMaterialDetail) {
                  let tempMaterial = {}
                  let adMaterialDetail = item.adMaterialDetail
                  tempMaterial.fileCryptUrl = adMaterialDetail.fileCryptUrl
                  tempMaterial.fileId = adMaterialDetail.fileId
                  tempMaterial.fileMd5 = adMaterialDetail.fileMd5
                  tempMaterial.fileType = adMaterialDetail.fileType
                  tempMaterial.fullImageFileId = adMaterialDetail.fileId
                  tempMaterial.fullImageFileMd5 = adMaterialDetail.fileMd5
                  tempMaterial.fullImageFileUrl = adMaterialDetail.fileUrl
                  tempMaterial.fullImageUrl = adMaterialDetail.fileUrl
                  tempMaterial.videoSnapshotUrl =
                    adMaterialDetail.videoSnapshotUrl
                  tempMaterial.materialInfo = JSON.parse(
                    adMaterialDetail.materialInfo || {}
                  )
                  tempMaterial.model = [item.deviceModelText]
                  tempMaterial.modelID = [item.deviceModel]
                  materialDetailsList.push(tempMaterial)
                }
              })

              editPlanDetail.regionIdToPointId = regionIdToPointId
              editPlanDetail.planMaterialList = planMaterialList
              editPlanDetail.adMaterials[0].precises &&
                sessionStorage.setItem(
                  'conditionList',
                  JSON.stringify(editPlanDetail.adMaterials[0].precises)
                )
              sessionStorage.setItem(
                'materialDetailsList',
                JSON.stringify(materialDetailsList)
              )
            }
            //多画面设置vue数据
            let info = this.setDateMaterialFormat(editPlanDetail.adMaterials[0])
            this.setFramesData(info)
            sessionStorage.setItem(
              'editPlanDetail',
              JSON.stringify(editPlanDetail)
            )
            this.upDate(editPlanDetail)
          } else {
            this.$message.warning('计划详情获取失败！')
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    init() {
      // 初始化
      // 获取 planID 如果planID为空则为新建计划
      let planID = window.sessionStorage.planId
      let type = window.sessionStorage.planSetType
      const step = window.sessionStorage.step
      if (planID) {
        // 编辑
        if (type === 'create') {
          this.getPlanEditDetail(planID)
        } else {
          this.createing()
        }
      } else {
        // 创建
        let formItem = null
        try {
          formItem = JSON.parse(window.sessionStorage.formItem)
        } catch {
          formItem = null
        }
        // 创建
        if (step > 0 && formItem) {
          this.createing()
        } else {
          sessionStorage.setItem('formItem', JSON.stringify(this.formItem))
          this.createing()
        }
      }
    },
    createing() {
      let formItem = JSON.parse(window.sessionStorage.formItem)

      this.formItem = formItem
      let { userType, assistCreatePlan } = this.userInfo
      this.$nextTick(() => {
        if (formItem.companyId !== '-') {
          if (userType === 5) {
            //初始化来源公司
            this.form.setFieldsValue({
              originCompanyId: formItem.originCompanyId,
            })
            //初始化来源销售
            this.form.setFieldsValue({ originUserId: formItem.originUserId })
            this.getCompanyForUserId(formItem.originUserId)
            this.getOriginUser(formItem.originCompanyId)
          } else if (assistCreatePlan === 1) {
            //初始化所属销售
            this.form.setFieldsValue({ saleId: formItem.saleId })
            this.getCompanyForUserId(formItem.saleId)
          } else {
            // this.getCompanyForUserId(this.userInfo.userId);
          }
          // 初始化公司名称
          this.form.setFieldsValue({ company: formItem.companyId })
          // 初始化公司品牌
          this.getBrandsForid(formItem.companyId)
          this.form.setFieldsValue({ brand: formItem.companyBrand })
          // 初始化计划名称
          this.form.setFieldsValue({ planName: formItem.planName })
          // 初始化广告类型（广告主行业）
          this.form.setFieldsValue({ adType: formItem.adSystemId || [] })
          // 初始化计费方式
          this.form.setFieldsValue({
            isBilling: String(formItem.priceStrategy),
          })
          // 初始化广告位置
          this.form.setFieldsValue({
            positionId: formItem.positionId,
          })
          //初始化播放时段deliveryPeriod
          this.form.setFieldsValue({
            deliveryPeriod: String(formItem.deliveryPeriod),
          })
        }
      })
    },
    //编辑
    upDate(editPlanDetail) {
      let { userType } = this.userInfo
      let _this = this
      if (editPlanDetail.saleId) {
        editPlanDetail.saleId = editPlanDetail.saleId.toString()
      }
      if (userType === 5) {
        // 全国媒介单
        this.formItem.originCompanyId = editPlanDetail.originCompanyId
        this.formItem.originCompanyName = editPlanDetail.originCompanyName
        this.formItem.originUserId = editPlanDetail.originUserId.toString()
        this.formItem.originUserName = editPlanDetail.originUserName
        this.getCompanyForUserId(editPlanDetail.originUserId)
        this.getOriginUser(editPlanDetail.originCompanyId)
      }
      // playCounts
      this.formItem.isDuration = editPlanDetail.playDuration
      this.formItem.playDuration = editPlanDetail.playDuration
      this.formItem.playTimes = editPlanDetail.playTimes
      this.formItem.playCounts = editPlanDetail.playTimes
      this.formItem.companyId = editPlanDetail.companyId
      this.formItem.saleId = editPlanDetail.saleId
      this.formItem.companyName = editPlanDetail.companyName
      this.formItem.companyBrandId = editPlanDetail.brandId
      this.formItem.companyBrand = editPlanDetail.bTitle
      this.formItem.planName = editPlanDetail.planName
      // this.formItem.adSystemId = JSON.parse(formItem.adCategoryJson);
      this.formItem.adSystemName = editPlanDetail.adSystemName
      this.formItem.priceStrategy = String(editPlanDetail.priceStrategy)
      this.formItem.beginTime = editPlanDetail.beginTime
      this.formItem.endTime = editPlanDetail.endTime
      this.formItem.adSystemName = editPlanDetail.adCategoryName
      this.formItem.positionId = editPlanDetail.positionId
      this.formItem.deliveryPeriod = editPlanDetail.deliveryPeriod

      //初始化所属销售
      if (userType === 5) {
        this.form.setFieldsValue({
          originCompanyId: this.formItem.originCompanyId,
        })
        this.form.setFieldsValue({
          originUserId: this.formItem.originUserId,
        })
      }
      //初始化所属销售
      if (this.userInfo.assistCreatePlan == 1) {
        this.getCompanyForUserId(this.formItem.saleId)
        this.form.setFieldsValue({ saleId: this.formItem.saleId })
      }
      // 初始化公司名称
      this.form.setFieldsValue({ company: this.formItem.companyId })
      // 初始化公司品牌
      this.getBrandsForid(this.formItem.companyId)
      this.form.setFieldsValue({ brand: this.formItem.companyBrandId })
      // 初始化计划名称
      this.form.setFieldsValue({ planName: this.formItem.planName })
      // 初始化广告类型
      // this.form.setFieldsValue({ adType: this.formItem.adSystemId });
      // 初始化计费方式
      this.form.setFieldsValue({
        isBilling: String(this.formItem.priceStrategy),
      })
      // 初始化公司品牌选项
      var brands = this.companyNames.filter(function (item) {
        return item.cID == _this.formItem.companyId
      })
      if (brands.length) {
        this.companyBrands = brands[0].companyBrand
      }
      // 初始化广告位置
      this.form.setFieldsValue({
        positionId: this.formItem.positionId,
      })
      this.form.setFieldsValue({
        deliveryPeriod: String(this.formItem.deliveryPeriod),
      })
    },
    // 获取来源公司
    getOriginCompany() {
      api.getApi('/ascrInfo/getAll', {}).then((res) => {
        if (res.data.code === 200) {
          this.originCompanyList = res.data.data.map((item) => {
            return {
              value: item.id,
              label: item.name,
            }
          })
        } else {
          this.$message.warning(res.data.msg || '来源公司异常')
        }
      })
    },
    backStep() {
      this.$router.push('./channelAdPlan')
    },
    nextStep() {
      let info = {}
      if (sessionStorage.getItem('formItem') != undefined) {
        info = JSON.parse(sessionStorage.getItem('formItem'))
      }
      //判断广告位置是否更改
      if (info.positionId != this.formItem.positionId) {
        //如果修改
        this.clearAdMaterialDetail('positionId')
        if (this.formItem.positionId == 3 || this.formItem.positionId == 4) {
          this.formItem.isDuration = '5'
          this.formItem.playSecond = '5'
        } else {
          this.formItem.isDuration = '10'
          this.formItem.playSecond = '10'
        }
      }
      //判断展现机制是否更改
      if (info.priceStrategy != this.formItem.priceStrategy) {
        // 轮播的三种时段的播放次数
        this.formItem.playCounts = ''
      }
      //判断广告位置是否是大屏轮播广告
      if (info.positionId == 2) {
        this.formItem.playCounts = 300
      } else if ([3, 4, 5].includes(info.positionId)) {
        this.formItem.playCounts = ''
      }

      if (this.formItem.positionId != 1) {
        this.formItem.deliveryPeriod = null
      } else {
        //判断播放时段是否更改
        if (info.deliveryPeriod != this.formItem.deliveryPeriod) {
          //如果更改了就要替换缓存里面的数据，因为不同时段时常和次数都不一样。切换了就重置为10s开始
          this.formItem.playSecond = 10
          this.formItem.isDuration = 10 //重置搜索缓存时长 不知道为啥一样的值要写2个字段
        }
      }
      this.form.validateFields((err, values) => {
        if (!err) {
          sessionStorage.setItem('formItem', JSON.stringify(this.formItem))
          sessionStorage.setItem('planSetType', 'createing')
          this.$router.push('./channelTargetSet')
        }
      })
    },
    //输入名称搜索
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      )
    },
    // 选择来源公司
    changeOriginCompany(val, item) {
      this.formItem.originCompanyId = val
      this.formItem.originCompanyName = item.data.attrs.name
      this.formItem.originUserId = ''
      this.form.setFieldsValue({ originUserId: '' })
      this.form.setFieldsValue({ company: '' })
      this.form.setFieldsValue({ brand: '' })
      this.getOriginUser(val)
    },
    // 根据所选来源公司获取来源销售
    getOriginUser(val) {
      api.getApi('/ascrInfo/getSale', { asrId: val }).then((res) => {
        if (res.data.code === 200) {
          this.originUserList = res.data.data.map((item) => {
            return {
              value: item.userId,
              label: item.realName,
              userName: item.userName,
            }
          })
        } else {
          this.$message.warning(res.data.msg)
        }
      })
    },
    // 选择来源销售
    changeOriginUser(val, item) {
      this.formItem.originUserId = val
      this.formItem.originUserName = item.data.attrs.name
      this.companyNames = []
      this.form.setFieldsValue({ company: '' })
      this.form.setFieldsValue({ brand: '' })
      this.getCompanyForUserId(val)
    },
    //选择所属销售
    changeSale(val, data) {
      this.form.setFieldsValue({ saleId: val })
      this.formItem.saleId = val
      this.companyNames = []
      this.form.setFieldsValue({ company: '' })
      this.form.setFieldsValue({ brand: '' })
      this.getCompanyForUserId(val)
    },
    //获取销售
    getSales() {
      api.getApi('/common/company/getSale').then((res) => {
        if (res.data.code == 200) {
          this.sales = res.data.data
        } else {
          this.$message.warning(res.data.msg)
        }
      })
    },
    //根据销售获取公司名称
    getCompanyForUserId(id) {
      api
        .getApi('/common/company/getCompanyByUserId', { userId: id })
        .then((res) => {
          if (res.data.code == 200) {
            var ad_users = res.data.data
            //公司名字公司品牌
            var ad_comband = []
            ad_users.forEach(function (item, index) {
              var sigle_comband = {
                companyNames: item.cName,
                cID: item.cID,
              }
              ad_comband.push(sigle_comband)
            })
            this.companyNames = ad_comband
          } else {
            this.$message.warning(res.data.msg)
          }
        })
    },
    // 选择公司之后，更改公司品牌选项
    changeCompany(val, data) {
      this.formItem.companyId = val
      this.formItem.companyName = data.data.attrs.name
      this.getBrandsForid(val)
    },
    //根据公司id获取公司品牌
    getBrandsForid(id) {
      let that = this
      api
        .getApi('/customerManager/getBrandList', { companyId: id })
        .then((res) => {
          if (res.data.code == 200) {
            this.companyBrands = res.data.data
            setTimeout(() => {
              if (res.data.data.length > 0) {
                that.form.setFieldsValue({ brand: res.data.data[0].bTitle })
                that.formItem.companyBrand = res.data.data[0].bTitle
                that.formItem.companyBrandId = res.data.data[0].bID
                sessionStorage.setItem(
                  'formItem',
                  JSON.stringify(that.formItem)
                )
              } else {
                that.form.setFieldsValue({ brand: '' })
                that.formItem.companyBrand = ''
                that.formItem.companyBrandId = ''
                sessionStorage.setItem(
                  'formItem',
                  JSON.stringify(that.formItem)
                )
              }
            }, 150)
          } else {
            this.$message.warning(res.data.msg)
          }
        })
    },
    // 选择公司品牌
    changeBrands(val, data) {
      let companyBrand = ''
      // 通过选中的id获取对于的值
      this.companyBrands.forEach(function (i) {
        if (i.bID == val) {
          companyBrand = i.bTitle
        }
      })
      this.formItem.companyBrandId = val
      this.formItem.companyBrand = companyBrand
      // this.$store.commit('changeFormItem',this.formItem)
    },
    // 选择计划名称
    changePlanName(val) {
      this.formItem.planName = val.target.value
      // this.$store.commit('changeFormItem',this.formItem)
    },
    // 选择广告类型
    changeAdSystem(val, data) {
      var adSys = ''
      data.forEach(function (i, k) {
        if (k == 0) {
          adSys += i.label
        } else {
          adSys += '-' + i.label
        }
      })
      this.formItem.adSystemId = val
      this.formItem.adSystemName = adSys
      sessionStorage.setItem('formItem', JSON.stringify(this.formItem))
    },
    //选择计费方式
    changeAdType(e) {
      this.formItem.priceStrategy = e.target.value * 1
      this.formItem.positionId = null
      this.form.setFieldsValue({ positionId: this.formItem.positionId })
      this.formItem.deliveryPeriod = null //重置播放时段
      this.form.setFieldsValue({ deliveryPeriod: this.formItem.deliveryPeriod })
    },
    // 选择广告位置
    changePositionId(e) {
      this.formItem.positionId = e.target.value * 1
    },
    // 获取行业类型
    tradeList() {
      let ads = []
      let resinfo = []
      let hide = this.$message.loading('加载中...', 0)
      api
        .getApi('/customerManager/getIndustryList')
        .then((res) => {
          if (res.data.code === 200) {
            resinfo = res.data.data
            for (let data of resinfo) {
              let obj = {
                label: data.industryName,
                value: data.industryId,
                children: [],
              }
              for (let item of data.children) {
                let itemobj = {
                  label: item.industryName,
                  value: item.industryId,
                }
                obj.children.push(itemobj)
              }
              ads.push(obj)
            }
            this.adSys = ads
            setTimeout(hide, 500)
          } else {
            this.$message.warning(res.data.msg)
            setTimeout(hide, 500)
          }
        })
        .catch((err) => {
          console.log(err)
          setTimeout(hide, 500)
        })
    },
    strTotime(date) {
      var date = date
      date = date.substring(0, 19)
      date = date.replace(/-/g, '/')
      var timestamp = new Date(date).getTime()
      return timestamp
    },
    //选择播放时段
    changeDeliveryPeriodType(e) {
      this.formItem.deliveryPeriod = e.target.value * 1
    },
    //设置vuex数据
    setDateMaterialFormat(data) {
      //将时间段处理成单个的时间
      data.adMaterialDetail = data.adMaterialDetails
      data.adMaterialDetail.forEach((item) => {
        let _playDates = []
        item.playDates &&
          item.playDates.forEach((i) => {
            i = i.split('|')
            _playDates.push(...getDiffList(i[0], i[1], 'days'))
          })
        item.playDates = _playDates
      })
      // data.adMaterialDetail = array
      //添加审核状态
      return data
    },
    // getDiffList(beginTime, endTime, type) {
    //   //对年月日处理成年月moment(currentDate).format('YYYY-MM')
    //   var dateArray = [] // dateArray 起止日期中间的所有日期列表
    //   var currentDate = moment(beginTime) //起止日期
    //   var stopDate = moment(endTime) //截止日期
    //   //开始日期小于等于结束日期,并循环
    //   while (currentDate <= stopDate) {
    //     if (type === 'days')
    //       dateArray.push(moment(currentDate).format('YYYY-MM-DD')) //两个日期间的所有日期
    //     if (type === 'months')
    //       dateArray.push(moment(currentDate).format('YYYY-MM')) //两个月份间的所有月份
    //     if (type === 'years') dateArray.push(moment(currentDate).format('YYYY')) //两个年份间的所有年份
    //     currentDate = moment(currentDate).add(1, type) //根据类型+1
    //   }
    //   return dateArray
    // },
  },
}
</script>
<style lang="scss">
.row-flex {
  display: flex;
}
.warn-box {
  .ant-alert-message {
    color: rgba(0, 0, 0, 0.65);
  }
}
.m-planSet {
  .u-modle-p {
    width: 100%;
    height: 42px;
    background: rgba(240, 242, 245, 0.41);
    font-size: 18px;
    font-family: PingFangSC-Regular;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.85);
    line-height: 42px;
    padding-left: 24px;
    margin-bottom: 32px;
  }
  .m-set-mell {
    margin: auto;
    width: 384px;
  }
  .m-foot-btn {
    width: 180px;
    margin: 32px auto 16px;
    .u-nextStep-btn {
      margin-left: 8px;
    }
  }
}
.user-name {
  width: 77px;
  height: 22px;
  font-size: 14px;
  font-family: 'PingFangSC-Regular,PingFang SC';
  font-weight: 400;
  color: rgba(0, 0, 0, 0.25);
  line-height: 22px;
}
.m-planSet .ant-form-item {
  margin: 0 auto;
  width: 450px;
  margin-bottom: 32px;
}

.ant-form-item-control-wrapper {
  width: auto;
}

#startTime .ant-input,
#endTime .ant-input {
  width: 284px;
}

.ant-calendar-footer {
  display: none;
}

.u-radio-tooltip {
  margin-right: 10px;
  margin-left: -10px;
}
</style>
